export default "__VITE_ASSET__C$z7haXN__"